//
//
//
//
//
//
//
//
//
//

import Locations from '~/components/common/Locations'

export default {
    components: {
        Locations,

    },
    props: [
        'content',
    ],
    async asyncData({ $storyblok, store, params }) {
        const page = await $storyblok.getPage('pages/locations')
        store.commit('setPage', page)
        return {
            page: page,
        }
    },
    head() {
        return this.$metadata(this.page)
    }
}
